module.exports = __webpack_public_path__ + "img/habanero.becfb607.svg";